import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../global";
import FormPrint from "./formPrint";
import { Autocomplete, Button, TextField, Toolbar } from "@mui/material";
import axios from "axios";
import vssStamp from "../image/visibleSafety/himtexStamp.png";
import haryanaStamp from "../image/visibleSafety/COMPETENT PERSON HARYANA.png";
import rajasthanStamp from "../image/visibleSafety/COMPETENT PERSON RAJASTHAN STAMP.png";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import { generatePDF1, drawReportOnDoc } from "./print";
import jsPDF from "jspdf";
import { useLocation } from "react-router";
import axiosWithToken from "../../utils/components/axiosTokenConfig";

// Helper to prepare form data by fetching necessary info
const prepareFormData = async (id, templateId) => {
  const [reportRes, templateRes] = await Promise.all([
    axiosWithToken.get(`${BASE_URL}reportValues/${id}`),
    axiosWithToken.get(`${BASE_URL}templates/${templateId}`)
  ]);

  const reportData = reportRes.data[0];
  const templateData = templateRes.data[0];

  const templateValues = JSON.parse(reportData.templateValues || "{}");

  const inputFields = await axios.get(templateData?.url).then(res => res.data);

  const stateKeyArrayBase = [
    "competentPerson", "reportNumber", "reportDate", "shopId","issueDate",
    "equipmentId", "totalTest", "capacity", "renewalInformation ",
    "inspectionDate ", "certificateValidity ", "inspectionDate",
    "utrasonicTestDate", "hydraulicTestDate", "internalTestDate",
    "internalExaminationDueDate", "certificateValidityDate", "renewalInformation",
    "certificateValidity", "tagNumber","reportStateName","renewal","hydrostaticTest","dateOfLastTest", "certifyDate","inspectedOn","conclusionOfCertificate","certificateNumber"
  ];

  const stateKeyArray =  stateKeyArrayBase;
  // templateData?.name === "Form13"
    // ? [...stateKeyArrayBase, "Occupier", "location13"]
    // : 

  // Filter out fields which are already part of state keys
  const filteredInputFields = inputFields.filter(
    (field) => !stateKeyArray.includes(field.stateKey)
  );
  // Fetch additional lookup data
  const [factoryList, shopList, productList, competentData] = await Promise.all([
    axiosWithToken.get(BASE_URL + `clients`).then(res => res.data),
    axiosWithToken.get(BASE_URL + `shops`).then(res => res.data),
    axiosWithToken.get(BASE_URL + `products`).then(res => res.data),
    templateValues?.competentPerson
      ? axiosWithToken.get(BASE_URL + `competents/${templateValues?.competentPerson}`).then(res => res.data?.[0])
      : Promise.resolve(null)
  ]);
    // let stamp = {15: rajasthanStamp, 16: haryanaStamp}[templateData?.branchId] || vssStamp;

   let extraprops ={
    certificateNo : reportData.reportNo, 
    newTemplateID : templateId,
    newReportID : id,
    // stamLogo : stamp,
    competentPerson : competentData
  }

  return {
    formInfo: templateData,
    inputStates: templateValues,
    filteredInputFields,
    Factory: factoryList,
    Shop: shopList,
    Product: productList,
    selectedOption: competentData,
    approvedBy: reportData?.approvedBy,
    extraprops
  };
};

const MultiplePrintForm = () => {
  const location = useLocation();
  const [ids, setIds] = useState([]);
  const [FormData, setFormData] = useState([]);
  const [downloadPdfloading, setDownloadPdfloading] = useState(false);
  const [letterHead, setLetterHead] = React.useState(true);

  // Fetch form data for given ids
  const fetchFormData = () => {
    try {
      if (ids.length === 0) return;
      let SQLQuery = {
        query: `SELECT id, templateId FROM reportValues WHERE id IN (${ids.join(
          ","
        )}) ORDER BY id DESC`,
      };

      axiosWithToken.post(BASE_URL + `dynamic`, SQLQuery).then((res) => {
        let data = res.data;
        setFormData(data);
      });
    } catch (e) {
      console.log("Failed to fetch checklist template: ", e);
    }
  };

  useEffect(() => {
    if (ids?.length > 0) fetchFormData();
  }, [ids]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const idsParam = searchParams.get("ids");
    if (idsParam) {
      const idsArray = idsParam.split(",").map((id) => parseInt(id)).filter((id) => !isNaN(id));
      setIds(idsArray);
    }
  }, [location.search]);

  // Handle multiple PDF downloads sequentially
  const handleMultipleDownload = async () => {
    if (FormData.length === 0) return;

    setDownloadPdfloading(true);
    
    const doc = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a4",
      compress: true,
    });

    for (let i = 0; i < FormData.length; i++) {
      const { id, templateId } = FormData[i];
      try {
        const data = await prepareFormData(id, templateId);
        if (i > 0) doc.addPage();
        await drawReportOnDoc(
          doc,
          letterHead,
          data.formInfo,
          data.inputStates,
          data.filteredInputFields,
          data.Factory,
          data.Shop,
          data.Product,
          data.extraprops
        );
      } catch (err) {
        console.error(`Failed to generate PDF for id ${id}:`, err);
      }
    }

    doc.save(`reports.pdf`);
    setDownloadPdfloading(false);
  };

  return (
    <>
      <Toolbar
            style={{
              padding: "0px",
              overflow: "auto",
              display: "flex",
              justifyContent: "end",
              gap:2
            }}
          >
        <Autocomplete
          size="small"
          id="invoice_view_letterhead"
          options={[
            { id: 1, label: "With Letter Head" },
            { id: 2, label: "Without Letter Head" },
          ]}
          renderInput={(params) => (
            <TextField {...params} label="Letter Head" />
          )}
          sx={{ height: "40px", width: "250px" }} // Match the height to Button
          onInputChange={(event, newInputValue) => {
            if (
              newInputValue === "With Letter Head" ||
              newInputValue === ""
            ) {
              setLetterHead(true);
            } else if (newInputValue === "Without Letter Head") {
              setLetterHead(false);
            }
          }}
        />
            <Button
              variant="contained"
              size="small"
              sx={{ marginRight: "20px" }}
              onClick={handleMultipleDownload}
              disabled={downloadPdfloading || FormData.length === 0}
            >
              Multiple Report Print
            </Button>
          </Toolbar>
    <div>
      {FormData?.sort((a, b) => a.id - b.id)?.map((ele) => (
          <div key={ele.id}>
            <FormPrint
            selectedFormID={ele?.id}
            selectedTemplateID={ele?.templateId}
            />
            
          </div>
        ))}
    </div>
  
    {downloadPdfloading && (
        <DownloadPdfLoaderModal loading={downloadPdfloading} name={"Pdf"} />
      )}
    </>
  );
};

export default MultiplePrintForm;